import type { FaireProductEntity } from "../../entity_types/product";

export const p_snaf5qpdnc: FaireProductEntity = {
  token: "p_snaf5qpdnc",
  type: "product",
  name: "Solid XL Shea Butter Shampoo Bar (Natural Fragrances)",
  brandToken: "b_3yerfaqmmt",
  brandName: "Desesh",
  imageUrl:
    "https://cdn.faire.com/fastly/9e0ca8ea0ea662f220c4eb844cef50b3b725f5cefdac06e90cae70623390b973.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5be4b942267fc35d24215771ec3795d9962170ab35bea757edc8fe55c094219.jpeg",
    "https://cdn.faire.com/fastly/8db91d3c46b94897764ee003130bbf2721b21d2fd4386ddd043b1537eeaa0336.jpeg",
    "https://cdn.faire.com/fastly/ee6b3e3d34a466c0660d781b04af74eaffd1638c8a2db7103b81424e2826faac.png",
    "https://cdn.faire.com/fastly/856a89b1f61395b82e3646befb84c80fd52fdc48d8ccd9c88874717c6502610b.png",
    "https://cdn.faire.com/fastly/19d94da0504d63065d809f12840fc0ca2a89f1a9b1ce2a536fa81630fc086728.jpeg",
    "https://cdn.faire.com/fastly/edd2fea449c8b7ba71cb5ec4c1977719416285e8b354414c598b84fface4e5fc.jpeg",
    "https://cdn.faire.com/fastly/9eb30d98662129b379f8abe03294f1c2f0898ced320d8e243d69e4eecd2d5375.jpeg",
    "https://cdn.faire.com/fastly/c1edd071f25f77611a03cd4547b90cfb8657d23796617857bfc1ecd7905098aa.jpeg",
  ],
  priceDollars: 12.46,
  description:
    "50% larger than our Argan Oil bars that allow you to enjoy a premium salon-quality shampoo experience without the plastic bottle or harsh ingredients. Crafted in small batches in the USA, this concentrated solid bar is designed to replace 2-3 12oz bottles and is full of hydrating oils and nutrients. Use along with the conditioner bar to make your hair feel healthier, lighter, and bring back your natural shine. Made for all hair types and lathers up easily so you can use less. What's different? Premium quality ingredients, plastic free, phthalate free, paraben free, palm oil free, SLS free, vegan and cruelty free, no artificial fragrances or dyes, low waste plastic free cardboard packaging and made in small batches in the United States.",
  tags: [],
  msrpDollars: 24.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:45.104Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
